import React, { useState, useEffect } from 'react';
import InfoCard from '../../DashboardComponents/InfoCard/InfoCard';
import './DashboardProjects.css'
import PieChartCard from '../../DashboardComponents/PieChartCard/PieChartCard';
import MuiTable from '../../DashboardComponents/MuiTable/MuiTable';
import RowBarChartCard from '../../DashboardComponents/RowBarChartCard/RowBarChartCard';

export default function DashboardProjects({data}) {
    // Table Data
    const tableDatatest = [{
        "id": 1,
        "first_name": "Mada",
        "last_name": "Gallandre",
        "email": "mgallandre0@ted.com",
        "gender": "Female",
        "ip_address": "41.204.181.52"
      }, {
        "id": 2,
        "first_name": "Ari",
        "last_name": "Gowrie",
        "email": "agowrie1@scientificamerican.com",
        "gender": "Male",
        "ip_address": "226.77.9.209"
      }, {
        "id": 3,
        "first_name": "Fee",
        "last_name": "Pittendreigh",
        "email": "fpittendreigh2@ocn.ne.jp",
        "gender": "Male",
        "ip_address": "206.152.192.3"
      }, {
        "id": 4,
        "first_name": "Larisa",
        "last_name": "Stening",
        "email": "lstening3@apple.com",
        "gender": "Female",
        "ip_address": "10.47.113.72"
      }, {
        "id": 5,
        "first_name": "Iseabal",
        "last_name": "Markwelley",
        "email": "imarkwelley4@pen.io",
        "gender": "Female",
        "ip_address": "178.76.77.94"
      }, {
        "id": 6,
        "first_name": "Terence",
        "last_name": "Wrintmore",
        "email": "twrintmore5@qq.com",
        "gender": "Male",
        "ip_address": "59.104.74.121"
      }, {
        "id": 7,
        "first_name": "Michal",
        "last_name": "Van der Linde",
        "email": "mvanderlinde6@cocolog-nifty.com",
        "gender": "Non-binary",
        "ip_address": "30.251.163.212"
      }, {
        "id": 8,
        "first_name": "Jeni",
        "last_name": "Ciccerale",
        "email": "jciccerale7@deviantart.com",
        "gender": "Female",
        "ip_address": "102.35.162.0"
      }, {
        "id": 9,
        "first_name": "Mark",
        "last_name": "Bulley",
        "email": "mbulley8@buzzfeed.com",
        "gender": "Male",
        "ip_address": "77.138.178.172"
      }, {
        "id": 10,
        "first_name": "Enos",
        "last_name": "MacCaughan",
        "email": "emaccaughan9@oaic.gov.au",
        "gender": "Male",
        "ip_address": "30.229.245.232"
      }];

    const [tableData, settableData] = useState({
      data: [],
    });

    // Pie chart data
    const [pieChartData, setpieChartData] = useState({
      series: [],
      labels: [],
    });
    
    // Row chart data help projects
    const [rowBarChartDataHelp, setRowBarChartDataHelp] = useState({
      series: [
          {
            data: [] // Start with an empty array
          }
      ],
      categories: [] // Start with an empty array,
    });

    // Row chart data popular projects (top5projects)
    const [rowBarChartDataProjects, setRowBarChartDataProjects] = useState({
      series: [
          {
            data: [] // Start with an empty array
          }
      ],
      categories: [] // Start with an empty array,
    });

    // Row chart data popular project tags (top5projectTags)
    const [rowBarChartDataTags, setRowBarChartDataTags] = useState({
      series: [
          {
            data: [] // Start with an empty array
          }
      ],
      categories: [] // Start with an empty array,
    });

    useEffect(() => {
      if (data) {
          setRowBarChartDataHelp({
              series: [
                  {
                    data: data.helpProjects.map(project => project.user_count || 0) // Default to 0 if user_count is NaN or undefined
                  }
              ],
              categories: data.helpProjects.map(project => project.title || "Untitled Project") // Default to "Untitled Project" if title is missing
          });

          const percentages = Object.values(data.projectPhases.percentage); // Convert percentage object to array
          const phases = Object.values(data.projectPhases.phases); // Convert phases object to array
          
          setpieChartData({
            series: percentages,
            labels: phases
          });

          const projecttags = Object.keys(data.top5projectTags); // Get the project tags (keys)
          const count_tags = Object.values(data.top5projectTags); // Get the backers count (values)
          
          setRowBarChartDataTags({
            series: [
                {
                    data: count_tags // Backers count
                }
            ],
            categories: projecttags // Project tags
          });
          
          const projectnames = Object.values(data.top5projects.title);
          const likescount_project = Object.values(data.top5projects.likes);

          setRowBarChartDataProjects({
            series: [
                {
                    data: likescount_project // Backers count
                }
            ],
            categories: projectnames // Project names
        });
        const transformedData = Object.keys(data.projectsTableData.id).map(key => ({
          id: data.projectsTableData.id[key],
          title: data.projectsTableData.title[key],
          details: data.projectsTableData.details[key],
          category: data.projectsTableData.category[key],
          recruiting: data.projectsTableData.recruiting[key],
          phase: data.projectsTableData.phase[key],
          project_private_mode: data.projectsTableData.project_private_mode[key],
          likes: data.projectsTableData.likes[key]
        }));

        settableData({
          data: transformedData
        });

      }
    }, [data]);

    return (
        <div>
          <div className='projectsrow1'>
            <RowBarChartCard rowBarChartData={rowBarChartDataProjects} label={'Top 5 Projects'}/>
            <RowBarChartCard rowBarChartData={rowBarChartDataTags} label={'Top 5 Project Tags'}/>
            <RowBarChartCard rowBarChartData={rowBarChartDataHelp} label={'Member count'}/>
            <div className='projectSpecial'>
              <PieChartCard pieChartData={pieChartData} pieChartHeight={150} pieChartTitle='Project phases'/>
              {/* <InfoCard cardLabel={'AI generated project tag'}/> */}
            </div>
            {/* <InfoCard cardText={'Help Projects'}/> */}
          </div>
          <div className='projectsrow2'>
            <MuiTable tableData={tableData.data}/>
          </div>
        </div>
    );
}